<template>
  <v-container>
    <v-row justify="center" align="center" style="height: 100vh;">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-row>
  </v-container>
</template>

<script>
import a from '@/utils/axios/axios'

export default {
  created() {
    const external_service_id = this.$route.query.external_service_id
    const player_name = this.$route.query.player_name

    if(external_service_id && !player_name) {
      a.get(`/league/game/external/${external_service_id}`)
        .then(response => {
          const game_id = response.data.id
          this.$router.replace(`/games/${game_id}`)
        })
        .catch(error => {
          console.error('Error fetching game:', error)
          this.$router.push('/games')
        })
    } else {
      a.post(`/league/player/external`, {
        player_name,
        external_service_id
      })
        .then(response => {
          const filter = response.data;
          this.$router.replace(`/filter/nosave?filter=${JSON.stringify(filter)}`)
        })
        .catch(error => {
          console.error('Error fetching player:', error)
          this.$router.push('/games')
        })
    }
  }
}
</script>